import {useEffect,useState} from 'react';
import {useLocation} from 'react-router';
import {api} from '../api';
import {withBuildingScope} from './building-scope';
/** Canonical New count, not a fabricated personal unread count. Failures are never shown as zero. */
export function InboxCount({building}:{building:string|undefined}){
 const location=useLocation(),key=building??'portfolio',inboxActive=location.pathname==='/communications';
 const [result,setResult]=useState<{key:string;count:number}>();
 useEffect(()=>{
  let active=true,reading=false;
  const load=async()=>{
   if(reading)return;reading=true;
   try{
    const data=await api<{building:string|null;new_count:number;drafts_to_review?:number}>(withBuildingScope('/api/communications/summary',building));
    if(!active)return;
    if(data.building!==(building??null)||!Number.isSafeInteger(data.new_count)||data.new_count<0){setResult(undefined);return;}
    setResult({key,count:data.new_count});
    window.dispatchEvent(new CustomEvent('blockgenie:mail-folder-summary',{detail:data}));
   }catch{if(active)setResult(undefined)}finally{reading=false;}
  };
  const receive=(event:Event)=>{
   const data=(event as CustomEvent<{building:string|null;new_count:number|null}>).detail;
   if(!active||data?.building!==(building??null))return;
   if(typeof data.new_count==='number'&&Number.isSafeInteger(data.new_count)&&data.new_count>=0)setResult({key,count:data.new_count});else setResult(undefined);
  };
  const refresh=()=>{if(!inboxActive)void load();};
  window.addEventListener('blockgenie:inbox-summary',receive);if(inboxActive)setResult(undefined);else void load();window.addEventListener('focus',refresh);
  // A finished read is discarded after a scope change; navigation does not turn a harmless count read into a failed request.
  return()=>{active=false;window.removeEventListener('focus',refresh);window.removeEventListener('blockgenie:inbox-summary',receive);};
 },[building,key,inboxActive]);
 const count=result?.key===key?result.count:undefined;
 return <span id="staff-inbox-count" className="inbox-count" aria-label={count===undefined?'New message count unavailable':`${count} new conversations`} title={count===undefined?'Count unavailable':'New conversations in this scope'}>{count??'—'}</span>;
}
